const B_1 = [
    {
        title: '投标保证金查看',
        path: '/bidding/projectflow/toubiao/marginview/list'
    }
]
export default {
    path: 'marginview',
    component: () => import(/*webpackChunkName: 'bidding-projectflow-toubiao-marginview'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/tou/margin-view/list'),
            meta: {
                title: '投标保证金查看',
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/tou/margin-view/detail'),
            meta: {
                title: '查看保证金记录',
                bread: '/bidding/projectflow/toubiao/marginview/detail'
            },
        }       
    ]
}